
export const onlyLettersString = (string) => {
    return /^[a-zA-Z_ ]*$/.test(string.trim());
}